import { render, staticRenderFns } from "./MemberPointsPopup.vue?vue&type=template&id=0b1f79e2&scoped=true"
import script from "./MemberPointsPopup.vue?vue&type=script&lang=js"
export * from "./MemberPointsPopup.vue?vue&type=script&lang=js"
import style0 from "./MemberPointsPopup.vue?vue&type=style&index=0&id=0b1f79e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f79e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1f79e2')) {
      api.createRecord('0b1f79e2', component.options)
    } else {
      api.reload('0b1f79e2', component.options)
    }
    module.hot.accept("./MemberPointsPopup.vue?vue&type=template&id=0b1f79e2&scoped=true", function () {
      api.rerender('0b1f79e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MemberPointsPopup.vue"
export default component.exports